module.exports = __webpack_public_path__ + "static/media/bshare-512.2218461d.png";